import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/media/images/BlackPakkelabel.png'
import _imports_1 from '@/assets/media/images/WhitePakkelabel.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-428d0f80")

_pushScopeId("data-v-428d0f80")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-8" }
const _hoisted_3 = { class: "row mb-5" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-header card-p border-0 d-flex align-items-center justify-content-between" }
const _hoisted_7 = { class: "card-header-title mb-0 p-0 fs-5" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus me-2" }, null, -1)
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { style: {"white-space":"nowrap"} }
const _hoisted_11 = {
  key: 0,
  class: "order-qty"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fas fa-minus" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  style: {"white-space":"nowrap"},
  class: "d-block fs-6"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_17 = { class: "row mb-5" }
const _hoisted_18 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_19 = { class: "card" }
const _hoisted_20 = { class: "card-header card-header-title mb-5 card-p fs-5" }
const _hoisted_21 = { class: "row mb-5" }
const _hoisted_22 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_23 = { class: "card" }
const _hoisted_24 = { class: "card-header card-header-title mb-5 card-p fs-5" }
const _hoisted_25 = { class: "address-list card-p" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_30 = { class: "card" }
const _hoisted_31 = { class: "card-header card-header-title mb-5 card-p fs-5" }
const _hoisted_32 = { class: "address-list card-p" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "col-md-4" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-12" }
const _hoisted_38 = {
  key: 0,
  class: "card mb-5 card-p"
}
const _hoisted_39 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_40 = { class: "d-flex flex-wrap align-items-center justify-content-between" }
const _hoisted_41 = { class: "d-flex flex-wrap align-items-center name-area" }
const _hoisted_42 = { class: "d-block fs-7 fw-300 mt-1" }
const _hoisted_43 = {
  key: 0,
  class: "d-block fs-7 fw-300 mt-2"
}
const _hoisted_44 = {
  key: 1,
  class: "card mb-5 card-p"
}
const _hoisted_45 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_46 = { class: "d-flex flex-wrap align-items-center justify-content-between" }
const _hoisted_47 = { class: "d-flex flex-wrap align-items-center name-area" }
const _hoisted_48 = { class: "d-block fs-7 fw-300 mt-1" }
const _hoisted_49 = {
  key: 2,
  class: "card mb-5 card-p"
}
const _hoisted_50 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_51 = { class: "summary-list" }
const _hoisted_52 = {
  key: 3,
  class: "card mb-5 card-p"
}
const _hoisted_53 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_54 = { class: "summary-list" }
const _hoisted_55 = {
  key: 4,
  class: "card mb-5 card-p"
}
const _hoisted_56 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_57 = {
  key: 0,
  class: "summary-list"
}
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "subscription-title" }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "card mb-5 card-p" }
const _hoisted_62 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_63 = {
  key: 0,
  class: "summary-list"
}
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "card-header-title mb-4 p-0 fs-5" }
const _hoisted_66 = { class: "sap-status-row" }
const _hoisted_67 = { class: "sap-status-label" }
const _hoisted_68 = {
  key: 0,
  class: "sap-status-hint"
}
const _hoisted_69 = {
  key: 1,
  class: "sap-order-number"
}
const _hoisted_70 = {
  key: 6,
  class: "card mb-5 card-p"
}
const _hoisted_71 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_72 = { class: "remote-error-message" }
const _hoisted_73 = {
  key: 7,
  class: "card mb-5 card-p"
}
const _hoisted_74 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_75 = { class: "col-md-9" }
const _hoisted_76 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_77 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  height: "100",
  width: "100"
}, null, -1)
const _hoisted_78 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_79 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  height: "100",
  width: "100"
}, null, -1)
const _hoisted_80 = { class: "card mb-5 card-p" }
const _hoisted_81 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_82 = {
  key: 0,
  class: "summary-list"
}
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { key: 1 }
const _hoisted_85 = { key: 2 }
const _hoisted_86 = { class: "fs-4" }
const _hoisted_87 = { key: 3 }
const _hoisted_88 = {
  key: 8,
  class: "card mb-5 card-p"
}
const _hoisted_89 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_90 = { class: "card card-p" }
const _hoisted_91 = { class: "card-header-title mb-5 p-0 fs-5" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Table = _resolveComponent("Table")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AddOrderProducts = _resolveComponent("AddOrderProducts")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loader,
      innerLoading: false
    }, null, 8, ["loading"]),
    _createVNode(_component_InnerLoader, { loading: _ctx.sendMailLoader }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("header", _hoisted_6, [
                _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('message.ORDER_PRODUCT')), 1),
                (_ctx.canEditOrderProducts)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-custom fs-7 py-2 px-4",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openAddProducts && _ctx.openAddProducts(...args)))
                    }, [
                      _hoisted_8,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.ADD')) + " " + _toDisplayString(_ctx.$t('message.PRODUCTS')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", {
                class: ["order-products-table", { 'has-actions': _ctx.canEditOrderProducts }]
              }, [
                _createVNode(_component_Table, {
                  columns: _ctx.columns,
                  rows: _ctx.orders.order_products,
                  padding: 5
                }, {
                  "cell-image": _withId(({ row: item }) => [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("img", {
                        class: "order-product-thumb",
                        src: item?.product?.media?.length && item?.product?.media[0].file_path ? item.product.media[0].file_path : _ctx.defaultImage,
                        alt: ""
                      }, null, 8, ["src"])
                    ])
                  ]),
                  "cell-price": _withId(({ row: item }) => [
                    _createVNode("span", _hoisted_10, _toDisplayString(item?.price_label_without_tax), 1)
                  ]),
                  "cell-description": _withId(({ row: item }) => [
                    _createTextVNode(_toDisplayString(JSON.parse(item?.product?.description?.name)[_ctx.system_locale]?.name), 1)
                  ]),
                  "cell-quantity": _withId(({ row: item }) => [
                    (_ctx.canEditOrderProducts)
                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                          _createVNode("button", {
                            type: "button",
                            class: "order-qty-btn",
                            disabled: _ctx.loader || Number(item.quantity) <= 1,
                            title: _ctx.$t('message.QUANTITY'),
                            onClick: ($event: any) => (_ctx.changeOrderProductQuantity(item, Number(item.quantity) - 1))
                          }, [
                            _hoisted_12
                          ], 8, ["disabled", "title", "onClick"]),
                          _createVNode("input", {
                            class: "order-qty-field",
                            type: "number",
                            min: "1",
                            step: "1",
                            disabled: _ctx.loader,
                            value: item.quantity,
                            onChange: ($event: any) => (_ctx.changeOrderProductQuantity(item, $event.target.value))
                          }, null, 40, ["disabled", "value", "onChange"]),
                          _createVNode("button", {
                            type: "button",
                            class: "order-qty-btn",
                            disabled: _ctx.loader,
                            title: _ctx.$t('message.QUANTITY'),
                            onClick: ($event: any) => (_ctx.changeOrderProductQuantity(item, Number(item.quantity) + 1))
                          }, [
                            _hoisted_13
                          ], 8, ["disabled", "title", "onClick"])
                        ]))
                      : (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(item?.quantity), 1))
                  ]),
                  "cell-total": _withId(({ row: item }) => [
                    _createVNode("span", _hoisted_15, _toDisplayString(item?.total), 1)
                  ]),
                  "cell-actions": _withId(({ row: item }) => [
                    (_ctx.canEditOrderProducts)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          type: "button",
                          class: "order-row-delete",
                          title: _ctx.$t('message.DELETE'),
                          disabled: _ctx.loader,
                          onClick: ($event: any) => (_ctx.deleteOrderProduct(item))
                        }, [
                          _hoisted_16
                        ], 8, ["title", "disabled", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["columns", "rows"])
              ], 2)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          (_ctx.orders?.order_status)
            ? (_openBlock(), _createBlock("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _createVNode(_component_InnerLoader, {
                    loading: _ctx.loader,
                    innerLoading: true
                  }, null, 8, ["loading"]),
                  _createVNode("header", _hoisted_20, _toDisplayString(_ctx.$t('message.ORDER_STATUS')), 1),
                  _createVNode(_component_el_steps, {
                    "align-center": "",
                    active: _ctx.orderStatusStepActive,
                    "finish-status": "success",
                    class: "card-p order-status-steps"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_step, {
                        title: _ctx.i18n.t('message.ORDER_RECEIVED')
                      }, null, 8, ["title"]),
                      _createVNode(_component_el_step, {
                        title: _ctx.i18n.t('message.ORDER_IN_PROGRESS')
                      }, null, 8, ["title"]),
                      _createVNode(_component_el_step, {
                        title: _ctx.i18n.t('message.SHIPMENT_IN_PROGRESS')
                      }, null, 8, ["title"]),
                      _createVNode(_component_el_step, {
                        title: _ctx.i18n.t('message.ORDER_SHIPPED')
                      }, null, 8, ["title"])
                    ]),
                    _: 1
                  }, 8, ["active"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_21, [
          (_ctx.orders?.order_shipping_address)
            ? (_openBlock(), _createBlock("div", _hoisted_22, [
                _createVNode("div", _hoisted_23, [
                  _createVNode("header", _hoisted_24, _toDisplayString(_ctx.$t('message.SHIPPING_ADDRESS')), 1),
                  _createVNode("ul", _hoisted_25, [
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.CUSTOMER_NAME')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_shipping_address?.name), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.CITY')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_shipping_address?.city), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.COUNTRY')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_shipping_address?.country?.name), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.POSTAL_CODE')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_shipping_address?.postal_code), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ADDRESS')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_shipping_address?.address_1), 1)
                    ]),
                    (_ctx.orders?.order_shipping_address?.address_2)
                      ? (_openBlock(), _createBlock("li", _hoisted_26, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ADDRESSES')) + " 2", 1),
                          _createVNode("span", null, _toDisplayString(_ctx.orders.order_shipping_address.address_2), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.orders?.order_shipping_address?.phone_number)
                      ? (_openBlock(), _createBlock("li", _hoisted_27, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ACCOUNT_PHONE_NUMBER')), 1),
                          _createVNode("span", null, _toDisplayString(_ctx.orders.order_shipping_address.phone_number), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_28, [
          (_ctx.orders?.order_billing_address)
            ? (_openBlock(), _createBlock("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  _createVNode(_component_InnerLoader, {
                    loading: _ctx.loader,
                    innerLoading: true
                  }, null, 8, ["loading"]),
                  _createVNode("header", _hoisted_31, _toDisplayString(_ctx.$t('message.BILLING_ADDRESS')), 1),
                  _createVNode("ul", _hoisted_32, [
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.CUSTOMER_NAME')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_billing_address?.name), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.CITY')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_billing_address?.city), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.COUNTRY')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_billing_address?.country?.name), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.POSTAL_CODE')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_billing_address?.postal_code), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ADDRESS')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_billing_address?.address_1), 1)
                    ]),
                    (_ctx.orders?.order_billing_address?.address_2)
                      ? (_openBlock(), _createBlock("li", _hoisted_33, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ADDRESSES')) + " 2", 1),
                          _createVNode("span", null, _toDisplayString(_ctx.orders.order_billing_address?.address_2), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.orders?.order_billing_address?.phone_number)
                      ? (_openBlock(), _createBlock("li", _hoisted_34, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ACCOUNT_PHONE_NUMBER')), 1),
                          _createVNode("span", null, _toDisplayString(_ctx.orders.order_billing_address.phone_number), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_35, [
        _createVNode("div", _hoisted_36, [
          _createVNode("div", _hoisted_37, [
            (_ctx.customer)
              ? (_openBlock(), _createBlock("div", _hoisted_38, [
                  _createVNode("header", _hoisted_39, _toDisplayString(_ctx.$t('message.CUSTOMER_NAME')), 1),
                  _createVNode("div", _hoisted_40, [
                    _createVNode("div", _hoisted_41, [
                      _createVNode("div", {
                        class: "name-avatar",
                        style: 'background:' + _ctx.companyLogo(_ctx.customer?.user?.name)?.color
                      }, _toDisplayString(_ctx.companyLogo(_ctx.customer?.user?.name)?.name), 5),
                      _createVNode("h3", null, [
                        _createTextVNode(_toDisplayString(_ctx.customer?.user?.name) + " ", 1),
                        _createVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('message.ORDER_ID')) + " # " + _toDisplayString(_ctx.orders?.id), 1),
                        (_ctx.customer?.parent)
                          ? (_openBlock(), _createBlock("span", _hoisted_43, _toDisplayString(_ctx.$t('message.MANAGER_OF')) + " : " + _toDisplayString(_ctx.customer?.parent?.name), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.customer?.user?.roles == 'customer')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "view-all-details btn btn-custom fs-7",
                          to: {
                                    name: 'customer_detail',
                                    params: { uuid: _ctx.customer?.uuid }
                                },
                          onClick: _ctx.clearPageHistory
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.DETAILS')), 1)
                          ]),
                          _: 1
                        }, 8, ["to", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_44, [
                  _createVNode("header", _hoisted_45, _toDisplayString(_ctx.$t('message.CUSTOMER_NAME')), 1),
                  _createVNode("div", _hoisted_46, [
                    _createVNode("div", _hoisted_47, [
                      _createVNode("div", {
                        class: "name-avatar",
                        style: 'background:' + _ctx.companyLogo(_ctx.orders?.name)?.color
                      }, _toDisplayString(_ctx.companyLogo(_ctx.orders?.name)?.name), 5),
                      _createVNode("h3", null, [
                        _createTextVNode(_toDisplayString(_ctx.orders?.name) + " ", 1),
                        _createVNode("span", _hoisted_48, "Order ID # " + _toDisplayString(_ctx.orders?.id), 1)
                      ])
                    ])
                  ])
                ])),
            (_ctx.customer)
              ? (_openBlock(), _createBlock("div", _hoisted_49, [
                  _createVNode("header", _hoisted_50, _toDisplayString(_ctx.$t('message.CUSTOMER_INFORMATION')), 1),
                  _createVNode("ul", _hoisted_51, [
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.EMAIL')), 1),
                      _createVNode(_component_el_tooltip, {
                        class: "item",
                        effect: "dark",
                        content: _ctx.customer?.user?.email,
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.customer?.user?.email), 1)
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.PHONE_NUMBER')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.customer?.phone_number), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.CUSTOMER_GROUP')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.customer?.customer_group?.name), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.STATUS')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.customer?.user?.status == 1 ? _ctx.$t('message.ACTIVE') : _ctx.$t('message.INACTIVE')), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ORDER_CREATED_AT')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders.created_at), 1)
                    ])
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_52, [
                  _createVNode("header", _hoisted_53, _toDisplayString(_ctx.$t('message.CUSTOMER_INFORMATION')), 1),
                  _createVNode("ul", _hoisted_54, [
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.EMAIL')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders.email), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.PHONE_NUMBER')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders.order_shipping_address?.phone_number), 1)
                    ])
                  ])
                ])),
            (_ctx.orders?.order_subscription_history?.order_subscription_id || _ctx.orders?.order_discount?.discount_id)
              ? (_openBlock(), _createBlock("div", _hoisted_55, [
                  _createVNode("header", _hoisted_56, _toDisplayString(_ctx.$t('message.ORDER_INFORMATION')), 1),
                  (Object.values(_ctx.orderTotals).length != 0)
                    ? (_openBlock(), _createBlock("ul", _hoisted_57, [
                        (_ctx.orders?.order_subscription_history?.order_subscription_id)
                          ? (_openBlock(), _createBlock("li", _hoisted_58, [
                              _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ORDER')), 1),
                              _createVNode("span", _hoisted_59, _toDisplayString(_ctx.$t('message.SUBSCRIPTIONS_ORDERS')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.orders?.order_discount?.discount_id)
                          ? (_openBlock(), _createBlock("li", _hoisted_60, [
                              _createVNode("strong", null, _toDisplayString(_ctx.$t('message.DISCOUNT_CODE')), 1),
                              _createVNode("span", null, _toDisplayString(_ctx.orders?.order_discount?.discount?.code), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_61, [
              _createVNode("header", _hoisted_62, _toDisplayString(_ctx.$t('message.ORDER_PAYMENT_INFORMATION')), 1),
              (Object.values(_ctx.orderTotals).length != 0)
                ? (_openBlock(), _createBlock("ul", _hoisted_63, [
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.PAYMENT_METHOD')), 1),
                      (_ctx.orders.order_payment)
                        ? (_openBlock(), _createBlock("span", _hoisted_64, _toDisplayString(JSON.parse(_ctx.orders?.order_payment?.payment_method?.name)[_ctx.system_locale]?.name), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.TRANSACTION_ID')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_payment?.transaction_id), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isOrderSendFailed)
              ? (_openBlock(), _createBlock("div", {
                  key: 5,
                  class: ["card mb-5 card-p sap-status-card", { 'is-failed': _ctx.isOrderSendFailed }]
                }, [
                  _createVNode("header", _hoisted_65, _toDisplayString(_ctx.$t('message.EXTERNAL_ORDER_STATUS')), 1),
                  _createVNode("div", _hoisted_66, [
                    _createVNode("span", _hoisted_67, _toDisplayString(_ctx.$t('message.ECONOMIC_STATUS')), 1),
                    _createVNode("span", {
                      class: ["badge", _ctx.isOrderSendFailed ? 'badge-light-danger' : 'badge-light-success']
                    }, _toDisplayString(_ctx.isOrderSendFailed ? _ctx.$t('message.NOT_SENT') : _ctx.$t('message.SENT')), 3)
                  ]),
                  (_ctx.isOrderSendFailed)
                    ? (_openBlock(), _createBlock("p", _hoisted_68, _toDisplayString(_ctx.$t('message.FORTNOX_ORDER_NOT_PLACED')), 1))
                    : _createCommentVNode("", true),
                  (!_ctx.isOrderSendFailed && _ctx.orders?.economic_order_number)
                    ? (_openBlock(), _createBlock("div", _hoisted_69, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('message.ECONOMIC_NUMBER')), 1),
                        _createVNode("strong", null, _toDisplayString(_ctx.orders.economic_order_number), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isOrderSendFailed)
                    ? (_openBlock(), _createBlock("button", {
                        key: 2,
                        type: "button",
                        class: "btn btn-custom sap-resend-btn",
                        disabled: _ctx.sapResendLoader,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resendOrderEconomic(_ctx.orders?.id)))
                      }, _toDisplayString(_ctx.sapResendLoader ? _ctx.$t('message.SENDING') : _ctx.i18n.t('message.RESEND')), 9, ["disabled"]))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.formattedRemoteResponse)
              ? (_openBlock(), _createBlock("div", _hoisted_70, [
                  _createVNode("header", _hoisted_71, _toDisplayString(_ctx.$t('message.ERROR')), 1),
                  _createVNode("div", _hoisted_72, _toDisplayString(_ctx.formattedRemoteResponse), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.orders?.order_shipment)
              ? (_openBlock(), _createBlock("div", _hoisted_73, [
                  _createVNode("header", _hoisted_74, [
                    _createVNode("div", _hoisted_75, _toDisplayString(_ctx.$t('message.SHIPMENT_ORDER_STATUS')), 1),
                    (_ctx.asideTheme === 'light')
                      ? (_openBlock(), _createBlock("div", _hoisted_76, [
                          _hoisted_77
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_78, [
                          _hoisted_79
                        ]))
                  ]),
                  _createVNode(_component_el_steps, {
                    direction: "vertical",
                    active: 
                                _ctx.orders.order_shipment?.is_fulfilled == 0
                                    ? 0
                                    : _ctx.orders.order_shipment?.is_fulfilled == 1 && _ctx.orders.order_shipment?.tracking_id == null
                                    ? 1
                                    : _ctx.orders.order_shipment?.is_fulfilled == 1 && _ctx.orders.order_shipment?.tracking_id != null && _ctx.orders.order_shipment?.is_notified == 0
                                    ? 2
                                    : _ctx.orders.order_shipment?.is_fulfilled == 1 && _ctx.orders.order_shipment?.tracking_id != null && _ctx.orders.order_shipment?.is_notified == 1
                                    ? 3
                                    : ''
                            ,
                    class: "order-status-steps shipment-summary-status",
                    "finish-status": "success"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_step, {
                        title: 
                                    _ctx.orders.order_shipment?.is_fulfilled == 0
                                        ? _ctx.i18n.t('message.ORDER_HAS_NOT_BEEN_FULFILLED')
                                        : _ctx.orders.order_shipment?.is_fulfilled == 1
                                        ? _ctx.i18n.t('message.ORDER_HAS_BEEN_FULFILLED')
                                        : ''
                                
                      }, null, 8, ["title"]),
                      _createVNode(_component_el_step, {
                        title: _ctx.i18n.t('message.TRACKING_ID') + ' : '
                      }, _createSlots({ _: 2 }, [
                        (_ctx.orders.order_shipment?.tracking_id != null)
                          ? {
                              name: "title",
                              fn: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.i18n.t('message.TRACKING_ID')) + " : ", 1),
                                _createVNode("a", {
                                  href: _ctx.orders.order_shipment?.url,
                                  target: "_blank"
                                }, _toDisplayString(_ctx.orders.order_shipment?.tracking_id), 9, ["href"])
                              ])
                            }
                          : {
                              name: "title",
                              fn: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.i18n.t('message.TRACKING_ID')) + " : " + _toDisplayString('N/A'), 1)
                              ])
                            }
                      ]), 1032, ["title"]),
                      _createVNode(_component_el_step, {
                        title: _ctx.i18n.t('message.MESSAGE_SENT')
                      }, _createSlots({ _: 2 }, [
                        (_ctx.orders.order_shipment?.is_notified == 0)
                          ? {
                              name: "title",
                              fn: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.i18n.t('message.MESSAGE_NOT_SENT')), 1)
                              ])
                            }
                          : {
                              name: "title",
                              fn: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.i18n.t('message.MESSAGE_SENT')) + " ", 1),
                                _createVNode("span", {
                                  class: "resed-msg",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resendMsg(_ctx.orders?.id)))
                                }, " : " + _toDisplayString(_ctx.i18n.t('message.RESEND')), 1)
                              ])
                            }
                      ]), 1032, ["title"])
                    ]),
                    _: 1
                  }, 8, ["active"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_80, [
              _createVNode("header", _hoisted_81, _toDisplayString(_ctx.$t('message.ORDER_SUMMARY')), 1),
              (Object.values(_ctx.orderTotals).length != 0)
                ? (_openBlock(), _createBlock("ul", _hoisted_82, [
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.SUB_TOTAL')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orderTotals?.sub_total?.value), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.orderTotals?.shipping?.title), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orderTotals?.shipping?.value), 1)
                    ]),
                    (_ctx.orders.site.prices_with_tax == 0 && _ctx.orderTotals?.discount)
                      ? (_openBlock(), _createBlock("li", _hoisted_83, [
                          _createVNode("strong", null, _toDisplayString(_ctx.orderTotals?.discount?.title), 1),
                          _createVNode("span", null, "-" + _toDisplayString(_ctx.orders?.discount_price_without_tax), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.orders.site.prices_with_tax == 1 && _ctx.orderTotals?.discount)
                      ? (_openBlock(), _createBlock("li", _hoisted_84, [
                          _createVNode("strong", null, _toDisplayString(_ctx.orderTotals?.discount?.title), 1),
                          _createVNode("span", null, "-" + _toDisplayString(_ctx.orders?.discount_price_with_tax), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.orders.site.prices_with_tax == 0)
                      ? (_openBlock(), _createBlock("li", _hoisted_85, [
                          _createVNode("strong", null, _toDisplayString(_ctx.orderTotals?.tax?.title), 1),
                          _createVNode("span", null, _toDisplayString(_ctx.orderTotals?.tax?.value), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("li", _hoisted_86, [
                      _createVNode("strong", null, _toDisplayString(_ctx.orderTotals?.total?.title), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orderTotals?.total?.value), 1)
                    ]),
                    (_ctx.orders.site.prices_with_tax == 1)
                      ? (_openBlock(), _createBlock("li", _hoisted_87, [
                          _createVNode("strong", null, _toDisplayString(_ctx.orderTotals?.tax?.title), 1),
                          _createVNode("span", null, _toDisplayString(_ctx.orderTotals?.tax?.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.orders?.order_notes && _ctx.orders?.order_notes?.length)
              ? (_openBlock(), _createBlock("div", _hoisted_88, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orders.order_notes, (orderNotes, index) => {
                    return (_openBlock(), _createBlock("div", { key: index }, [
                      _createVNode("header", _hoisted_89, _toDisplayString(orderNotes.note_type == 'NOTE' ? 'Note' : 'PO Number'), 1),
                      _createVNode("div", {
                        innerHTML: orderNotes?.note
                      }, null, 8, ["innerHTML"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_90, [
              _createVNode("header", _hoisted_91, _toDisplayString(_ctx.$t('message.ORDER_STATUS')), 1),
              _createVNode(_component_Select, {
                name: "order_status",
                target: "order_status",
                onChange: _ctx.updateStatus,
                placeholder: `${_ctx.$t('message.ORDER_STATUS')}`,
                order_status: _ctx.order_status,
                "onUpdate:order_status": _cache[4] || (_cache[4] = ($event: any) => (_ctx.order_status = $event)),
                selectData: _ctx.statusList,
                clearable: false,
                callEmit: true,
                value: _ctx.orders?.order_status?.status ? JSON.parse(_ctx.orders?.order_status?.status)[_ctx.system_locale]?.name : null,
                disabled: _ctx.orders?.order_status_id == 3 || _ctx.orders?.order_status_id == 6
              }, null, 8, ["onChange", "placeholder", "order_status", "selectData", "value", "disabled"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_AddOrderProducts, {
      ref: "addOrderProductsRef",
      onAdded: _ctx.refreshOrder
    }, null, 8, ["onAdded"])
  ], 64))
})